export default __webpack_public_path__ + "assets/img/LivenessGIF-3.e11e1c80.gif";